import React, { useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { coin } from '../RewardsGuide/svg';
import { bigCoin } from './svg';
// import { FAQ} from '../../../svg';

const faqs = [
    {
        question: `How do I list my property on the platform?`,
        answer: `
     To list your property, provide essential details about your property, such as location, size, and pricing preferences or call us at 08048811281 for assistance .
    `
    },
    {
        question: `Who will see my property listing?`,
        answer: `Your property will be visible to a vast network of potential tenants actively searching for rentals on our platform. You won’t receive unnecessary calls from brokers or unqualified tenants – we manage inquiries for you to ensure a smooth experience.
    
    `
    },
    {
        question: `What happens after I list my property?`,
        answer: `
     Once listed, your property will start receiving inquiries from interested tenants, and you can respond to their questions and set up viewings.
    `
    },
    {
        question: `Can I update my property details after listing?`,
        answer: `
       Yes, you can update property information like pricing or availability as needed by accessing your listing on the platform.
    `
    },

    {
        question: `Is there a fee for listing my property?`,
        answer: `
          Listing your property on our platform is free of charge. We handle the process, including managing tenant inquiries, so you can avoid unnecessary hassle.
      `
    }
];

const FAQ = () => {
    const history = useHistory();
    const [expanded, setExpanded] = useState(null);

    const toggleExpand = (index, question) => {
        setExpanded((prev) => (prev === index ? null : index));
        if (expanded !== index) {
            window?.webengage?.track('FAQExpanded', {
                Number: index + 1,
                QuestionText: question
            });
        }
    };
    return (
        <div className="w-full flex flex-col lg:flex-row items-center lg:items-start justify-between gap-8 pt-20 mx-auto max-w-[1200px]">
            {/* FAQ Section */}
            <section className="w-full lg:w-3/4">
                <div className="w-full flex flex-col lg:flex-row items-center lg:items-start justify-start mb-8">
                    <div className="relative z-20">{FAQ}</div>
                    <div className="ml-4 lg:w-[70%]">
                        <h3 className="font-bold text-[22px] lg:text-[28px] pb-px">
                            Frequently Asked Questions
                        </h3>
                        <p className="mt-2 text-[16px] text-gray-500">
                            Quick answers to the questions you may have
                        </p>
                    </div>
                </div>
                <div className="mt-8 space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="border rounded-lg p-4 cursor-pointer bg-white shadow-sm"
                            onClick={() => {
                                window?.webengage?.track('FAQClicked', { Question: faq.question });
                                toggleExpand(index, faq.question);
                            }}
                        >
                            <div className="flex justify-between items-center">
                                <h3 className="text-lg font-medium">{faq.question}</h3>
                                {expanded === index ? (
                                    <svg
                                    id="Group_11555"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="26"
                                    height="26"
                                    viewBox="0 0 26 26"
                                    className="flex-shrink-0"
                                >
                                    <rect
                                        width="26"
                                        height="26"
                                        rx="6"
                                        fill="#4652a4"
                                    />
                                    <rect
                                        width="14"
                                        height="2"
                                        rx="1"
                                        transform="translate(6 12)"
                                        fill="#fff"
                                    />
                                </svg>
                                ) : (
                                    <svg
                                    id="Group_11555"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="26"
                                    height="26"
                                    viewBox="0 0 26 26"
                                    className="flex-shrink-0"
                                >
                                    <g
                                        fill="#fff"
                                        stroke="#ddd"
                                        strokeWidth="1"
                                    >
                                        <rect
                                            width="26"
                                            height="26"
                                            rx="6"
                                            stroke="none"
                                        />
                                        <rect
                                            x="0.5"
                                            y="0.5"
                                            width="25"
                                            height="25"
                                            rx="5.5"
                                            fill="none"
                                        />
                                    </g>
                                    <g transform="translate(6 5.5)">
                                        <rect
                                            width="14"
                                            height="2"
                                            rx="1"
                                            transform="translate(0 6)"
                                            fill="#4652a4"
                                        />
                                        <rect
                                            width="14"
                                            height="2"
                                            rx="1"
                                            transform="translate(8) rotate(90)"
                                            fill="#4652a4"
                                        />
                                    </g>
                                </svg>
                                )}
                            </div>
                            {expanded === index && (
                                <div className="mt-3 text-gray-600">
                                    <p dangerouslySetInnerHTML={{ __html: faq.answer }} />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </section>
            
            {/* Banner Section */}
            <div className="w-full lg:w-1/3 flex justify-center lg:justify-end">
                <div
                    className="w-full h-[450px] lg:w-[320px] lg:h-[505px] bg-cover bg-center flex flex-col items-start px-6 pt-8 rounded-2xl shadow-lg text-white"
                    style={{ backgroundImage: `url("https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1740680701118_FaqBanner")` }}
                >
                    <div className='mt-4'>{bigCoin}</div>
                    <h2 className="text-[14px] lg:text-base font-semibold mt-2">
                        Refer your Friends
                    </h2>
                    <p className="text-[18px] lg:text-[24px] font-bold mt-1">
                        Get 200 Pts<br />
                        <span className="font-semibold text-base">Instantly</span>
                    </p>
                    <button 
                        className="mt-2 bg-white text-black py-2 px-4 rounded-lg mb-6"
                        onClick={() => history.push('/gift-and-earn')}
                    >
                        Refer Now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FAQ;
